import mapFunction from './mapResources';

export default mapFunction('notifications', {
    isFetching: false,
    items: [] 
});